import {
  Box,
  Button,
  PlusIcon,
  Typography
} from "@dealer-center/core-components";

export interface HeaderProps {
  subtitle: string;
  title: string;
}

export const Header = ({ subtitle, title }: HeaderProps) => (
  <Box
    sx={{
      alignItems: { md: "center", xs: "flex-start" },
      display: "flex",
      flexDirection: { md: "row", xs: "column" },
      gap: 2,
      justifyContent: "space-between"
    }}
  >
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography variant="h1">{title}</Typography>
      <Typography variant="body-md">{subtitle}</Typography>
    </Box>
    <Button
      analyticsConfiguration={{ eventName: "nrt_mapping_tool_add_record" }}
      buttonStyle="primary"
      startIcon={<PlusIcon title="" />}
    >
      Add New Record
    </Button>
  </Box>
);
